  
  // components/common/Pagination.tsx
  import React from 'react';
import { PaginationProps } from '../../types';
  
  export const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    onPageChange,
  }) => {
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    
    return (
      <div className="py-3 flex items-center justify-center">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-2 py-1 text-[#696969]  ${
              page === currentPage
                ? 'bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border'
                : 'hover:bg-gray-50'
            }`}
          >
           {String(page).padStart(2, "0")}
            
          </button>
        ))}
      </div>
    );
  };